module.exports = __webpack_public_path__ + "img/inception-hcms-blue.2aae6e5a.png";